import {recurringInvoiceSvg as Icon__small__recurringInvoiceSvg} from '../Icon__small/Icon__small--recurringInvoice.js';

export var recurringInvoice = {
  name: 'recurringInvoice',
  category: 'icon',
  colorable: true,
  svg: Icon__small__recurringInvoiceSvg,
};
